<div class="app-shell">
  @if (errorMessage()) {
    <div class="error-banner">
      {{ errorMessage() }}
    </div>
  } @else {
    <router-outlet />
  }
</div>
